import React, { useEffect, useState } from 'react';
import './SCSS/style.scss';
import './App.css';
import App from './App';
import Store from './store/store';
import { StoreProvider } from './store/storeUtils';
import { ApolloProvider } from '@apollo/client';
import API from './client/GraphqlClient';
import { create } from 'mobx-persist';
import { loadCss, loadFavicon } from './utils/HTMLInjector';
import translation from './i18n/en-GB/translation.json';
import { initI18n } from '@tecma/i18n';
const hydrate = create({});
const store = new Store();
const Floorplanning = ({
  routerBasename,
  forceLogin,
  socket,
  hostname,
  backToNeurosales
}) => {
  const [content, setContent] = useState(null);
  useEffect(() => {
    initI18n(translation, {
      bucketBase: `${"https://objectstorage.eu-frankfurt-1.oraclecloud.com/n/fronf8xprl08/b/tecma-assets-coll/o"}`,
      productName: 'floorplanning',
      apiBase: "https://api-staging.tecmasolutions.com/biz-tecma-demo-prod/i18n/v1/labels" || '',
      expirationTime: 1000 * 60,
      // 1 minuto,
      cache: 'no-cache'
    }).then(() => {
      hydrate('store_floorplanning', store).then(() => {
        const siteHost = hostname;
        loadFavicon(siteHost);
        loadCss(siteHost);
        setContent( /*#__PURE__*/React.createElement(StoreProvider, {
          value: store
        }, /*#__PURE__*/React.createElement(ApolloProvider, {
          client: API(store) //()=>{return API();}
        }, /*#__PURE__*/React.createElement("div", {
          id: "floorplanning-app"
        }, /*#__PURE__*/React.createElement(App, {
          componentMode: true,
          basename: routerBasename,
          forceLogin: forceLogin,
          socket: socket,
          hostname: hostname,
          backToNeurosales: backToNeurosales
        })))));
      });
    });
    return () => {
      // rimuovo il css di floorplanning per non interferire con quello di neurosales
      const linkNode = document.querySelector('#css-floorplanning');
      try {
        linkNode.parentNode.removeChild(linkNode);
      } catch (e) {
        console.error(e);
      }
    };
  }, []);
  return content;
};
export default Floorplanning;